import type { BaseItemSchema } from "@memorang/types/src/session/new-session";

/* -----------------Container--------------- */
import StudySessionItemContainer from "../../containers/StudySessionItemContainer";

import { useDevice } from "@hooks/useDevice";
/* -----------------Child components--------------- */
import Box from "@memorang/ui/src/components/Box";
import { useLocalSearchParams } from "expo-router";
import { sessionMaxWidth } from "../../constants";
import useSessionStore from "../../hooks/useSessionStore";

interface Props {
	items: BaseItemSchema[];
	toggleShowReadMore?: () => void;
}

const SessionListDesktop = ({ items, toggleShowReadMore }: Props) => {
	const { isMobile } = useDevice();
	const localSearchParams = useLocalSearchParams<{
		index: string;
		id: string;
	}>();

	const isSummativeTest = useSessionStore((state) => state.isSummativeTest);
	const index = localSearchParams.index
		? Number.parseInt(localSearchParams.index)
		: 0;
	const sessionId = localSearchParams?.id;
	const currentItem = index ? items[index - 1] : items[0];

	const shouldRenderHorizontalLayout =
		currentItem?.recordType === "SCENARIO" && !isMobile;

	return (
		<Box
			style={{
				width: "100%",
				height: "100%",
			}}
			maxWidth={
				isSummativeTest && !shouldRenderHorizontalLayout
					? sessionMaxWidth.summative
					: shouldRenderHorizontalLayout
						? 1300
						: sessionMaxWidth.formative
			}
		>
			<StudySessionItemContainer
				item={currentItem}
				toggleShowReadMore={toggleShowReadMore}
				sessionId={sessionId ? Number.parseInt(sessionId) : undefined}
			/>
		</Box>
	);
};
export default SessionListDesktop;
